module.exports = __webpack_public_path__ + "img/img-classify10.f40712a3.svg";